module.exports = __webpack_public_path__ + "static/media/edit.27aa1145.svg";